@import '../../_shared';

.form-input-holder__container {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;

  button {
    margin-top: 1.5rem;
    flex: .45;
  }
}
